<template>
  <div class="flex flex-col min-h-screen items-center">
    <div class="flex justify-between items-center w-full max-w-[1280px]">
      <div class="ml-4 sm:ml-0">
        <LogoIcon />
      </div>
      <div class="h-12 mt-5 mb-5 mr-4 sm:mr-8">
        <LanguageSwitch />
      </div>
    </div>
    <div class="max-w-[460px] w-full text-center flex-grow px-4">
      <h2 class="mt-5 mt-10 mb-6 text-center">
        {{ $t('messages.two_factor_auth.title') }}
      </h2>
      <p class="b1 block text-left text-zyxel-gray-800 mb-8">
        {{ $t('messages.two_factor_auth.otp_description') }}
      </p>
      <span class="b2 block text-left w-full mb-2 text-zyxel-gray-800">{{ $t('messages.text_input.code') }}</span>
      <input
        id="code"
        v-model="code"
        type="text"
        inputmode="numeric"
        :class="['text-input pt-4 pl-4 pb-4 text-left h-12 w-full mb-4', { 'error-input': errors.code }]"
        @keyup.enter="handleOTPVerify"
      >
      <span
        v-if="errors.code"
        class="error-message mt-1 b2 block text-left w-full"
      >{{
        $t(errors_msg.code) }}</span>
      <button
        class="button-primary w-full mt-4 mb-3"
        @click="handleOTPVerify"
      >
        {{ $t('messages.button.verify')
        }}
      </button>
    </div>
    <ZyxelFooter />
  </div>
</template>
<script>
import LogoIcon from '@/components/LogoIcon.vue';
import LanguageSwitch from "@/components/LanguageSwitch.vue";
import ZyxelFooter from "@/components/ZyxelFooter.vue";
import axios from 'axios';
import { apiBaseUrl } from '@/config';
import { logger } from '@/utils/logger';


export default {
    name: 'GoogleTwoFactorVerifyPage',
    components: {
        LogoIcon,
        LanguageSwitch,
        ZyxelFooter,
    },
    data() {
        return {
            code: '',
            errors: {
                code: false,
            },
            errors_msg: {
                code: false,
            }
        };
    },
    methods: {
        async handleOTPVerify() {
            if (!this.code) {
                this.errors.code = true;
                this.errors_msg.code = "messages.error_msg.otp_verify_failed";
                return;
            }
            this.errors.code = false;
            const queryParams = this.$route.query;
            const pre = queryParams.pre;
            const token = queryParams.token;

            try {
                const response = await axios.post(`${apiBaseUrl}/api/users/2fa/otp/verify_with_email_token`, { pincode: this.code, token: token });

                if (response.status === 200) {
                    this.$router.push({ name: 'ResetPasswordPage' , query: { pre: pre,  token: token, verified: true}});
                } else {
                    this.errors.code = true;
                    this.errors_msg.code = "messages.error_msg.otp_verify_failed";
                }
            } catch (error) {
                logger.log(error);
                this.errors.code = true;
                this.errors_msg.code = "messages.error_msg.otp_verify_failed";
            }
        }
    },
}
</script>